import { render, staticRenderFns } from "./SignalR.vue?vue&type=template&id=639c2655&"
import script from "./SignalR.vue?vue&type=script&lang=js&"
export * from "./SignalR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports